import Vue from 'vue'
import { login, logout, phoneLogin, thirdLogin } from "@/api/login"
import { ACCESS_TOKEN, USER_NAME,USER_INFO,USER_AUTH,SYS_BUTTON_AUTH,UI_CACHE_DB_DICT_DATA,TENANT_ID,CACHE_INCLUDED_ROUTES,DM_MENU_CACHE_KEY } from "@/store/mutation-types"
import { welcome } from "@/utils/util"
import { queryPermissionsByUser } from '@/api/api'
import { getAction } from '@/api/manage'

// ---- 账号数据隔离：登出时清理业务页残留配置，避免换账号后上一个账号的列宽/冻结/筛选模板/停留目录等串号 ----
// 业务页本地配置 key 前缀（列宽/列序/冻结/筛选/调列宽等，按页面前缀统一清理）
const BUSINESS_STORAGE_PREFIXES = [
  'dmDriver', 'driver', 'workOrder', 'workorder', 'js', 'car', 'phone',
  'jsRecord', 'userList', 'roleUser', 'notice', 'coupon', 'platformResizingMode',
  'dmFilterState_', 'filterTemplates_'
]
// 精确匹配的非页面 key（临时状态/浮层位置/排行停留目录/权限缓存/用户列表缓存/租户）
const BUSINESS_STORAGE_EXACT = [
  'GLOBAL_ADD_PENDING', 'fz_position', 'rankActiveSubMenu',
  USER_AUTH, SYS_BUTTON_AUTH, 'dm_sys_user_list_cache_v1', TENANT_ID
]
function clearBusinessStorage () {
  try {
    const hit = (k) => BUSINESS_STORAGE_PREFIXES.some(p => k.indexOf(p) === 0) || BUSINESS_STORAGE_EXACT.indexOf(k) > -1
    Object.keys(localStorage).forEach(k => { if (hit(k)) localStorage.removeItem(k) })
    Object.keys(sessionStorage).forEach(k => { if (hit(k)) sessionStorage.removeItem(k) })
  } catch (e) {
    // 清理失败不影响登出主流程
  }
}

const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    tenantid:'',
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TENANT: (state, id) => {
      state.tenantid = id
    },
  },

  actions: {
    // CAS验证登录
    ValidateLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getAction("/sys/cas/client/validateLogin",userInfo).then(response => {
          if(response.success){
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            // 新登录清掉旧账号的菜单缓存
            sessionStorage.removeItem(DM_MENU_CACHE_KEY)
            // 新登录清掉"退出记忆"：登录后默认进入"全部客户"页
            localStorage.removeItem('LAST_MENU_TITLE')
            resolve(response)
          }else{
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if(response.code =='200'){
            const result = response.result
            const loginUser = result.userInfo
            // 记住我：勾选写 localStorage（持久），不勾选写 sessionStorage（关标签即失效）
            if (userInfo.remember_me) {
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            } else {
              sessionStorage.setItem(ACCESS_TOKEN, result.token)
            }
            Vue.ls.set(USER_NAME, loginUser.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, loginUser, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', loginUser)
            commit('SET_NAME', { username: loginUser.username,realname: loginUser.realname, welcome: welcome() })
            commit('SET_AVATAR', loginUser.avatar)
            // 新登录清掉旧账号的菜单缓存
            sessionStorage.removeItem(DM_MENU_CACHE_KEY)
            // 新登录清掉"退出记忆"：登录后默认进入"全部客户"页
            localStorage.removeItem('LAST_MENU_TITLE')
            resolve(response)
          }else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    //手机号登录
    PhoneLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
          phoneLogin(userInfo).then(response => {
          if(response.code =='200'){
        const result = response.result
        const loginUser = result.userInfo
        // 记住我：勾选写 localStorage（持久），不勾选写 sessionStorage（关标签即失效）
        if (userInfo.remember_me) {
          Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
        } else {
          sessionStorage.setItem(ACCESS_TOKEN, result.token)
        }
        Vue.ls.set(USER_NAME, loginUser.username, 7 * 24 * 60 * 60 * 1000)
        Vue.ls.set(USER_INFO, loginUser, 7 * 24 * 60 * 60 * 1000)
        Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
        commit('SET_TOKEN', result.token)
        commit('SET_INFO', loginUser)
        commit('SET_NAME', { username: loginUser.username,realname: loginUser.realname, welcome: welcome() })
        commit('SET_AVATAR', loginUser.avatar)
        resolve(response)
      }else{
        reject(response)
      }
    }).catch(error => {
        reject(error)
      })
    })
    },
    // 获取用户信息
    GetPermissionList({ commit }) {
      return new Promise((resolve, reject) => {
        queryPermissionsByUser().then(response => {
          const menuData = response.result.menu;
          const authData = response.result.auth;
          const allAuthData = response.result.allAuth;
          //Vue.ls.set(USER_AUTH,authData);
          sessionStorage.setItem(USER_AUTH,JSON.stringify(authData));
          sessionStorage.setItem(SYS_BUTTON_AUTH,JSON.stringify(allAuthData));
          if (menuData && menuData.length > 0) {
            //update--begin--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
            menuData.forEach((item, index) => {
              if (item["children"]) {
                let hasChildrenMenu = item["children"].filter((i) => {
                  return !i.hidden || i.hidden == false
                })
                if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
                  item["hidden"] = true
                }
              }
            })
            //console.log(" menu show json ", menuData)
            //update--end--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
            commit('SET_PERMISSIONLIST', menuData)
            // 菜单数据存会话缓存,刷新后直接恢复路由,避免重复拉权限接口造成闪屏
            sessionStorage.setItem(DM_MENU_CACHE_KEY, JSON.stringify(menuData))
          } else {
            reject('getPermissionList: permissions must be a non-null array !')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token;
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        Vue.ls.remove(ACCESS_TOKEN)
        sessionStorage.removeItem(ACCESS_TOKEN)
        Vue.ls.remove(USER_INFO)
        Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
        Vue.ls.remove(CACHE_INCLUDED_ROUTES)
        sessionStorage.removeItem(DM_MENU_CACHE_KEY)
        // 清理业务页残留配置（列宽/冻结/筛选模板/停留目录/权限缓存/租户等），防止换账号数据串号
        clearBusinessStorage()
        // 退出即清除"退出记忆"：下次登录默认进入"全部客户"页
        localStorage.removeItem('LAST_MENU_TITLE')
        //console.log('logoutToken: '+ logoutToken)
        logout(logoutToken).then(() => {
          if (process.env.VUE_APP_SSO == 'true') {
            let sevice = 'http://' + window.location.host + '/'
            let serviceUrl = encodeURIComponent(sevice)
            window.location.href = process.env.VUE_APP_CAS_BASE_URL + '/logout?service=' + serviceUrl
          }
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
    // 第三方登录
    ThirdLogin({ commit }, param) {
      return new Promise((resolve, reject) => {
        thirdLogin(param.token,param.thirdType).then(response => {
          if(response.code =='200'){
            const result = response.result
            const userInfo = result.userInfo
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname, welcome: welcome() })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          }else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    saveTenant({ commit }, id){
      Vue.ls.set(TENANT_ID, id, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TENANT', id)
    }


  }
}

export default user